import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { DocumentStore } from "../../store/document/document.store";

export const providerDocumentResolver: ResolveFn<any> = async () => {
    const documentStore = inject(DocumentStore)
    try {
        await documentStore.getProviderDocuments()
    } catch(err) {
        console.error('Error fetching provider documents:', err);
    }
}